export default __webpack_public_path__ + "static/media/header_image.ef7aeae6.jpg";